import React from 'react';
import './OrderBy.scss';
import classnames from 'classnames';

export type OrderDir = 'asc' | 'desc';

type Props = {
  onChange: (changeParams: { keyName: string; orderDir: OrderDir }) => any;
  keyName: string;
  alignRight?: boolean;
};

const OrderBy = (props: Props) => {
  const { onChange, keyName, alignRight } = props;

  return (
    <div
      className={classnames('order-by', {
        'order-by__margin-left': alignRight,
        'order-by__margin-right': !alignRight,
      })}
    >
      <div
        className="order-by__up-arrow"
        onClick={() => onChange({ keyName, orderDir: 'asc' })}
      >
        <i className="fas fa-angle-up" />
      </div>

      <div
        className="order-by__down-arrow"
        onClick={() => onChange({ keyName, orderDir: 'desc' })}
      >
        <i className="fas fa-angle-down" />
      </div>
    </div>
  );
};

export default OrderBy;
